module.exports = __webpack_public_path__ + "web/img/grade4.43388c89.png";